import { render, staticRenderFns } from "./VcaPercentOfLoad.vue?vue&type=template&id=4cb62114&scoped=true"
import script from "./VcaPercentOfLoad.vue?vue&type=script&lang=ts"
export * from "./VcaPercentOfLoad.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb62114",
  null
  
)

export default component.exports